import { action } from "../common/Action"
import { BruciatoriClient, BruciatoreDto, BruciatoreDataDto } from "../generated";

const service = new BruciatoriClient();

class BruciatoriActions {
    @action
    async add(bruciatore: BruciatoreDataDto) {
        const id = await service.add(bruciatore);
        return { ...bruciatore, idBruciatore: id } as BruciatoreDto;
    }
    @action
    async update(id: number, bruciatore: BruciatoreDataDto) {
        await service.update(bruciatore, id);
        return { ...bruciatore, idBruciatore: id } as BruciatoreDto;
    }
    @action
    getbruciatore(id: number) {
        return service.get(id);
    };
    @action
    getAll() {
        return service.getAll()
    };
}
export default new BruciatoriActions();